import {IFreePlayVouchersProvider} from "../free-play-vouchers.provider.interface";
import {IFreePlayVoucherModel} from "../../vouchers/free-play-voucher.model.interface";
import {observable, runInAction} from "mobx";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {CGPEventSubscription} from "../../../sdk/cgp-sdk.interface";
import {VouchersProviderBase} from "../vouchers-provider-base";

export class ThirdPartyVouchersProvider extends VouchersProviderBase implements IFreePlayVouchersProvider {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        //TODO - when the game flow will completely be moved in orbit we need to move also the third party vouchers code
        this._cgpEventsSubscriptions.push(services.sdk.events.onThirdPartyVouchersReceived(vouchers => {
            runInAction(() => {
                this.vouchers.forEach(v => v.dispose());
                this.vouchers = vouchers.map(v => this._createVoucherModel(v)).filter(v => v);
            })
        }))
    }

    private _cgpEventsSubscriptions: CGPEventSubscription[] = [];

    @observable
    vouchers: IFreePlayVoucherModel[] = [];

    dispose(): void {
        this._cgpEventsSubscriptions.forEach(ev => ev.off());
        this._cgpEventsSubscriptions = [];
    }

    async refreshVouchers(): Promise<void> {
        await this.services.sdk.refreshThirdPartyVouchers();
    }
}